import { useContext } from 'react';

import { context } from './context';

export const useAuth = () => {
  return useContext(context);
};
